import React, { useEffect, useState } from 'react';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import { getEntityFilterConnectionsmeeting } from 'app/entities/connectionmeeting/connectionmeeting.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { createUserMeeting } from 'app/entities/meeting/meeting.reducer';
import { format } from 'date-fns';
import { components } from 'react-select';
import { default as ReactSelect } from 'react-select';
import makeAnimated from 'react-select/animated';
import MenteeQuestionsSelector from './MenteeQuestionsSelector';
interface User {
  name: string;
  email: string;
  selected: boolean;
  userId: string;
  image: string;
  occupation: string;
}

interface Props {
  connections: any;
}

const ConnectionMeetingForm: React.FC<Props> = ({ connections }) => {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [questionError, setquestionError] = useState('');
  const [duration, setDuration] = useState('');
  const [users, setUsers] = useState<User[]>([]);
  const [titleError, setTitleError] = useState('');
  const [dateError, setDateError] = useState('');
  const [timeError, setTimeError] = useState('');
  const [durationError, setDurationError] = useState('');
  const [userError, setUserError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [meetingType, setMeetingType] = useState('meeting'); // Default to 'meeting'
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const dispatch = useAppDispatch();
  const connectionMeetingEntity = useAppSelector(state => state.connectionmeeting.entity);
  const account = useAppSelector(state => state.authentication.account);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const SpecialCharacterRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~/\\]/;
  const baseImageUrl = '/profile/get/image';
  const defaultSelectedUser = users.find(user => user.userId === connections.userId);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    dispatch(getEntityFilterConnectionsmeeting(['connection', 'accepted']));
  }, []);
  useEffect(() => {
    if (Array.isArray(connectionMeetingEntity)) {
      const formattedUsers = connectionMeetingEntity.map(connection => ({
        value: connection.userId,
        image: connection.imageUrl,
        label: connection.userName,
        name: connection.userName,
        email: connection.email,
        selected: false,
        userId: connection.userId,
        occupation: connection.occupation,
      }));

      setUsers(formattedUsers);
    }
  }, [connectionMeetingEntity]);

  const [selectedUsers, setSelectedUsers] = useState<any>([]);

  const handleMeetingGuests = selected => {
    setUserError('');
    setSelectedOptions(selected);
    const selectedItems = selected.map(user => user.value);

    setSelectedUsers(selectedItems);
  };

  const Option = props => {
    return (
      <div>
        <components.Option {...props}>
          {/* <input type="checkbox" checked={props.isSelected} onChange={() => null} />&nbsp;&nbsp; */}
          <img src={`${baseImageUrl}/${props.data.image}`} width={30} height={30} className="rounded-circle" />
          &nbsp;&nbsp;
          <label> {props.label}</label>
        </components.Option>
      </div>
    );
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

    return now.toISOString().slice(0, 16);
  };

  const currentDate = getCurrentDateTime();

  const MAX_MEETING_DURATION_MS = 10 * 60 * 1000;
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Reset all error states
    setTitleError('');
    setDateError('');
    setTimeError('');
    setDurationError('');
    setUserError('');

    // Validate title (only for meetings)

    if (!title) {
      setTitleError('Please enter a title');
      return;
    }
    if (SpecialCharacterRegex.test(title)) {
      setTitleError('Special characters are not allowed');
      return;
    }

    // Validate date
    if (!date) {
      setDateError('Please enter a date');
      return;
    }

    // Validate duration
    if (!duration) {
      setDurationError('Please enter a duration');
      return;
    }

    if (meetingType === 'meeting' && selectedQuestions.length < 1) {
      setquestionError('Please select at least 1 question for meeting');
      return;
    }

    const durationValue = parseInt(duration, 10);
    const durationupdate = durationValue * 60000;

    if (isNaN(durationValue) || durationValue <= 0) {
      setDurationError('Meeting duration should be a positive number');
      return;
    }

    if (durationupdate > MAX_MEETING_DURATION_MS) {
      setDurationError('Meeting duration should not exceed 10 minutes');
      return;
    }

    // Validate users
    if (meetingType !== 'interview' && selectedUsers.length < 2) {
      setUserError('Please select at least 2 users');
      return;
    }
    if (meetingType === 'interview' && selectedUsers.length < 1) {
      setUserError('Please select at least 1 user for the interview');
      return;
    }

    try {
      const formattedDatetime = new Date(date);
      const meetingData = {
        name: title,
        createdByUserId: account.id,
        dateTime: formattedDatetime.getTime(),
        duration: durationupdate,
        guestsUserIds: selectedUsers,
        meetingType: meetingType === 'interview' ? 'Interview' : 'Meeting',
        questionIds: selectedQuestions,
      };

      const resultAction = await dispatch(createUserMeeting(meetingData));

      if (createUserMeeting.fulfilled.match(resultAction)) {
        setFormSubmitted(true);
      } else if (createUserMeeting.rejected.match(resultAction)) {
        const error = resultAction.error;
        setUserError(error.message || 'Failed to create meeting');
      }
    } catch (error) {
      setUserError('An unexpected error occurred');
    }
  };

  return (
    <>
      {!formSubmitted ? (
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label>Meeting Type</Label>
            <div>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="meetingType"
                    value="meeting"
                    checked={meetingType === 'meeting'}
                    onChange={() => setMeetingType('meeting')}
                  />
                  Meeting
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="meetingType"
                    value="interview"
                    checked={meetingType === 'interview'}
                    onChange={() => {
                      setMeetingType('interview');
                      setTitle('');
                      setTitleError('');
                    }}
                  />
                  Interview
                </Label>
              </FormGroup>
            </div>
          </FormGroup>
          <FormGroup>
            <Label for="text">
              Topic of Discussion <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              id="title"
              value={title}
              maxLength={100}
              onChange={e => {
                const trimmedValue = e.target.value.slice(0, 100);
                setTitle(trimmedValue);
                if (e.target.value.length > 100) {
                  setTitleError('Topic length must be at most 100 characters');
                } else {
                  setTitleError('');
                }
              }}
              onInput={() => setTitleError('')}
              invalid={!!titleError}
            />
            {titleError && <FormFeedback>{titleError}</FormFeedback>}
          </FormGroup>
          <FormGroup>
            <Label for="date">
              Date <span className="text-danger">*</span>
            </Label>
            <Input
              type="datetime-local"
              id="date"
              min={currentDate}
              value={date}
              onChange={e => {
                const selectedDate = e.target.value;
                if (selectedDate < currentDate) {
                  setDateError('Past dates and times are not allowed.');
                  return;
                }
                setDate(selectedDate);
              }}
              onInput={() => setDateError('')}
              invalid={!!dateError}
            />
            {dateError && <FormFeedback>{dateError}</FormFeedback>}
          </FormGroup>
          <FormGroup>
            <Label for="duration">
              Duration (in minutes) <span className="text-danger">*</span>
            </Label>
            <Input
              type="number"
              id="duration"
              value={duration}
              onChange={e => setDuration(e.target.value)}
              onInput={() => setDurationError('')}
              invalid={!!durationError}
              required
            />
            {durationError && <FormFeedback>{durationError}</FormFeedback>}
          </FormGroup>
          <Label for="Guests">
            Guests <span className="text-danger">*</span>
          </Label>
          <ReactSelect
            options={users}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={true}
            components={{
              Option,
            }}
            value={
              defaultSelectedUser
                ? [defaultSelectedUser, ...selectedOptions.filter(item => item.userId !== defaultSelectedUser.userId)]
                : selectedOptions
            }
            onChange={handleMeetingGuests}
            // allowSelectAll={true}
            // value={this.state.optionSelected}
          />
          {userError && <div className="text-danger">{userError}</div>}
          {meetingType === 'meeting' && (
            <MenteeQuestionsSelector userId={account.id} onChange={setSelectedQuestions} onchangeError={setquestionError} />
          )}
          {questionError && <div className="text-danger">{questionError}</div>}
          <Button type="submit" color="primary">
            Submit
          </Button>
        </Form>
      ) : (
        <div className="alert alert-success">{meetingType === 'meeting' ? 'Meeting' : 'Interview'} Created Successfully.</div>
      )}
    </>
  );
};
export default ConnectionMeetingForm;
